import * as yup from "yup";
import { LanguagesSlugs } from "@typeDefinitions";

interface Translation {
  lang: LanguagesSlugs;
  name: string | null;
}

export interface ProductUsageProgramScheduleResource {
  recipe: {
    id: number;
    name: string;
    translations: Translation[];
  };
  meal: {
    id: number;
    dietMeal: {
      id: number | null;
      name: string;
      translations: Translation[];
      hour: string;
    };
  };
  day: {
    id: number;
    programDay: {
      id: number;
    };
    date: string;
  };
}

const translationSchema = yup.object({
  lang: yup
    .mixed<LanguagesSlugs>()
    .oneOf([...Object.values(LanguagesSlugs)])
    .required(),
  name: yup.string().nullable().default(null),
});

const recipeSchema = yup.object({
  id: yup.number().required(),
  name: yup.string().required(),
  translations: yup.array().of(translationSchema).required(),
});

const dietMealSchema = yup.object({
  id: yup.number().nullable().default(null),
  name: yup.string().ensure(),
  translations: yup.array().of(translationSchema).required(),
  hour: yup.string().required(),
});

const mealSchema = yup.object({
  id: yup.number().required(),
  dietMeal: dietMealSchema.required(),
});

const daySchema = yup.object({
  id: yup.number().required(),
  programDay: yup
    .object({
      id: yup.number().required(),
    })
    .required(),
  date: yup.string().required(),
});

export const productUsageProgramScheduleSchema = yup.object({
  recipe: recipeSchema.required(),
  meal: mealSchema.required(),
  day: daySchema.required(),
});
